/* Footer email capture: subscribes to a Klaviyo list (client-side) and creates
   a Shopify customer, then reveals the inline discount code. */
(function () {
  var KLAVIYO_REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init(root) {
    if (root.dataset.tmSignupReady) return;
    root.dataset.tmSignupReady = '1';

    var form = root.querySelector('[data-tm-signup-form]');
    var input = form && form.querySelector('input[type="email"]');
    var btn = root.querySelector('[data-tm-signup-btn]');
    var status = root.querySelector('[data-tm-signup-status]');
    var success = root.querySelector('[data-tm-signup-success]');
    if (!form || !input) return;

    var klaviyoKey = (root.dataset.klaviyoKey || '').trim();
    var klaviyoList = (root.dataset.klaviyoList || '').trim();
    var source = root.dataset.source || 'Website signup';

    function setStatus(msg, kind) {
      if (!status) return;
      status.textContent = msg || '';
      status.className = 'tm-signup-status' + (kind ? ' is-' + kind : '');
    }

    // Subscribe to a Klaviyo list via the public client-side endpoint.
    function subscribeKlaviyo(email) {
      if (!klaviyoKey || !klaviyoList) return Promise.resolve(true);
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: klaviyoList } } }
        }
      };
      return fetch(
        'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(klaviyoKey),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
          body: JSON.stringify(payload)
        }
      ).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
        return true;
      });
    }

    // Best-effort Shopify customer creation (mirrors the old {% form 'customer' %}).
    function createShopifyCustomer(email) {
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', 'newsletter');
      return fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).catch(function () { /* non-blocking */ });
    }

    function showSuccess() {
      form.hidden = true;
      setStatus('', null);
      if (success) success.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        setStatus('Please enter a valid email address.', 'error');
        input.focus();
        return;
      }
      if (btn) btn.disabled = true;
      setStatus('Signing you up…', 'loading');

      subscribeKlaviyo(email)
        .then(function () {
          // Fire Shopify customer creation in parallel; don't block success on it.
          createShopifyCustomer(email);
          showSuccess();
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          setStatus('Something went wrong. Please try again.', 'error');
        });
    });

    // Copy-to-clipboard for the revealed discount code.
    var copyBtn = root.querySelector('[data-tm-code-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var valEl = copyBtn.querySelector('[data-tm-code-value]');
        var code = valEl ? valEl.textContent.trim() : '';
        if (!code || !navigator.clipboard) return;
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.classList.add('is-copied');
          setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1600);
        });
      });
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-tm-signup]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
